import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import MuiTabs from '@material-ui/core/Tabs';

const AppTabs = ({
  value,
  onChange,
  'aria-label': ariaLabel = 'app tabs',
  variant = 'scrollable',
  scrollButtons = 'off',
  AppBarProps = {},
  children,
  ...TabsProps
}) => (
  <AppBar position="static" elevation={0} component="div" {...AppBarProps}>
    <MuiTabs
      {...TabsProps}
      value={value}
      onChange={onChange}
      aria-label={ariaLabel}
      variant={variant}
      scrollButtons={scrollButtons}
      TabIndicatorProps={{ children: <span /> }}
    >
      {children}
    </MuiTabs>
  </AppBar>
);

AppTabs.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  'aria-label': PropTypes.string,
  variant: PropTypes.string,
  classes: PropTypes.object,
};

export default AppTabs;
